const Domain = window.location.hostname
const isAkTheDomain = Domain.includes('akthedashboard');

export const webEngageUserLogin = (uid) => {
    if (uid) {
        if (typeof window.Webengage != "undefined" && typeof window.Webengage.webEngageLogin == "function")
            window.Webengage.webEngageLogin(String(uid))
        else if (window.webengage)
            window.webengage.user.login(uid);
    }
}

export const webEngageUserLogout = () => {
    if (typeof window.Webengage != "undefined" && typeof window.Webengage.webEngageLogout == "function")
        window.Webengage.webEngageLogout()
    else
        window.webengage.user.logout();
}

export const trackWebEngageEvent = (name = "", parameters = {}) => {
    if (!name) {
        return
    }
    // window.webengage.init(webengage_init_key)
    // console.log(name, parameters);
    window.webengage.track(name, parameters);
}

export const webEngageUserAttr = (uid = false, opt = {}) => {
    if (uid) {
        webEngageUserLogin(uid)
        if (opt && typeof opt == "object" && Object.keys(opt).length) {
            if (window.webengage) {
                for (let [key, value] of Object.entries(opt)) {
                    let validValue = isNotEmpty(value) ? value : '';
                    window.webengage.user.setAttribute(key, validValue);
                }
            }
        }
    }
}


function isNotEmpty(value) {
    // Check if the value is null or undefined
    if (value === null || value === undefined) {
        return false;
    }

    // Check for empty strings
    if (typeof value === 'string' && value.trim() === '') {
        return false;
    }

    // Check for empty arrays
    if (Array.isArray(value) && value.length === 0) {
        return false;
    }

    // Check for empty objects
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
        return false;
    }

    // For any other data type that is not considered empty, return true
    return true;
}

let examType = isAkTheDomain?"AKTHE":'Anthe';

export let params = {
    mobile_number: '',
    roll_number: '',
    psid: '',
    class_opted: '',
    stream: '',
    state: '',
    center_name: '',
    center_code: '',
    scholarship_waiver_message: '',
    grade: '',
    anthe_rank_city: '',
    anthe_rank_state: '',
    anthe_all_India_rank: '',
    exam_type: examType,
    dashboard_autologin_url: '',
    scholarship_percent: ''

}